import React from 'react';
import { useRouter } from 'next/router';
import styled from 'styled-components';
import { Chip } from '@/components/atoms';
import { filterValidQueryParams } from '@/utils/Filters';
import { makeChips, makeChipsInBrand } from '@/utils/Catalog';
import { IChipsList } from '@/interfaces/index';

interface IStyledProps {
  isMobile?: boolean;
}

const List = styled.div<IStyledProps>`
  width: 100%;
  /* text-align: ${props => (props.isMobile ? 'none' : 'center')}; */
  /* ${props => props.theme.breakpoints.up('sm')} {
  ${props => props.theme.breakpoints.up('sm')} {
    padding-left: 16px;
    padding-right: 16px;
  } */
`;

const StyledChip = styled.div`
  display: inline-block;
  margin: 3px;
  ${props => props.theme.breakpoints.up('sm')} {
    margin: 4px;
  }
`;

const ChipsList: React.FC<IChipsList> = ({
  isMobile,
  collectionTags,
  currency,
  type,
}) => {
  const router = useRouter();
  const { slug, p, sort_by, ...queryParameters } = router.query;
  let validQueryParams = filterValidQueryParams(queryParameters);

  const chips =
    type === 'brands'
      ? makeChipsInBrand(
          router.pathname,
          slug,
          validQueryParams,
          collectionTags,
          currency?.symbol,
          sort_by as string
        )
      : makeChips(
          router.pathname,
          slug,
          validQueryParams,
          collectionTags,
          currency?.symbol,
          sort_by as string
        );

  const chipsElements = chips.map((chip, index) => {
    return (
      <StyledChip key={`chip-${index}`}>
        <Chip label={chip.label} urlPath={chip.href} shallow={true}></Chip>
      </StyledChip>
    );
  });

  return (
    <>
      {chipsElements && chipsElements.length > 0 && (
        <List isMobile={isMobile}>{chipsElements} </List>
      )}
    </>
  );
};

export default ChipsList;
